// Library Methods
import { useTranslation } from "react-i18next";
import { useContext, useMemo } from "react";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

const useProgressionAnalysisColumns = () => {
  const { t } = useTranslation();
  const { eyeType } = useContext(ReportSectionContext);

  const progressionAnalysisColumns = useMemo(() => {
    return [{ title: t("Eye"), value: t(eyeType), isBlueText: true }];
  }, [eyeType, t]);

  return { progressionAnalysisColumns };
};

export default useProgressionAnalysisColumns;
